import pick from "lodash/pick";

import { IUser } from "../../../types/auth/IUser";

import { userFields, SessionTypes } from "./constants";
import {
  SessionActions,
  AuthChangedSuccess,
  UserUpdateProfileSuccess,
} from "./actionTypes";
import { ISessionState } from "./ISessionState";

const defaultSessionState: ISessionState = {
  activeUser: null,
};

export function sessionReducer(state = defaultSessionState, { type, ...action }: SessionActions): ISessionState {
  switch (type) {
    case SessionTypes.AUTH_CHANGED_SUCCESS: {
      const { payload } = action as AuthChangedSuccess;

      return ({
        ...state,
        activeUser: payload !== null
          ? pick(payload, userFields) as IUser
          : payload,
      });
    }

    case SessionTypes.AUTH_USER_UPDATE_PROFILE_SUCCESS: {
      const { payload } = action as UserUpdateProfileSuccess;

      return ({
        ...state,
        activeUser: pick(payload, userFields) as IUser,
      });
    }

    default:
      return state;
  }
}
